'use strict';
import { j as e } from "../../external/react/jsx-runtime.js";
import l from "../../external/classnames/index.js";
import { useState as y, useEffect as F } from "react";
import { useTheme as B } from "../Provider/index.js";
import { FontAwesomeIcon as I } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faChevronDown as C } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
const L = ({
  heading: N,
  unit: h,
  placeholder: g,
  variant: t = "number",
  value: i,
  onChange: c,
  onBlur: w,
  className: j,
  error: u,
  options: a
}) => {
  const [o, d] = y(i), [x, k] = y(!1);
  F(() => {
    d(i);
  }, [i]);
  const m = (r) => {
    if (typeof r == "string")
      d(r), c(r);
    else {
      const f = r.target.value;
      if (t === "number") {
        const v = f.replace(/[^0-9]/g, "");
        d(v), c(v);
      } else
        d(f), c(f);
    }
  }, p = () => k(!0), b = () => {
    k(!1), w && w();
  }, { isMosh: n, isMoshy: s } = B();
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: l(
          "p-6 gap-4 border rounded-2xl transition-all",
          j,
          {
            "border-grey-200": !x,
            "border-green-faint-dark": x && n,
            "border-blue": x && s,
            "border-red-error": u
          }
        ),
        children: [
          /* @__PURE__ */ e.jsx(
            "p",
            {
              className: l("md:mb-2 mb-4 text-left font-demi", {
                "text-green-dark": n,
                "text-black": s
              }),
              children: N
            }
          ),
          /* @__PURE__ */ e.jsx("div", { className: "relative flex items-center gap-2", children: t === "dropdown" && a ? /* @__PURE__ */ e.jsxs("div", { className: "relative w-full", children: [
            /* @__PURE__ */ e.jsxs(
              "select",
              {
                value: o,
                onChange: m,
                onFocus: p,
                onBlur: b,
                className: l(
                  "w-full border border-grey-200 rounded-2xl appearance-none bg-white p-2",
                  {
                    "text-green-dark": n,
                    "text-black": s
                  },
                  { "text-grey-300": o === "" }
                ),
                children: [
                  /* @__PURE__ */ e.jsx("option", { value: "", disabled: !0, children: g || "Select..." }),
                  a.map((r) => /* @__PURE__ */ e.jsx(
                    "option",
                    {
                      value: r.value,
                      children: r.label
                    },
                    r.value
                  ))
                ]
              }
            ),
            /* @__PURE__ */ e.jsx(
              I,
              {
                icon: C,
                className: "absolute right-4 top-1/2 transform -translate-y-1/2 text-grey-400 pointer-events-none"
              }
            )
          ] }) : t === "radio" && a ? /* @__PURE__ */ e.jsx("div", { className: "flex w-full items-center gap-2", children: a.map((r) => /* @__PURE__ */ e.jsx(
            "button",
            {
              onClick: () => m(r.value),
              onFocus: p,
              onBlur: b,
              className: l(
                "font-demi rounded-lg border shadow-none cursor-pointer relative flex justify-center items-center text-center whitespace-nowrap overflow-hidden transition-all duration-200 ease-in-out disabled:cursor-auto w-full md:max-w-[398px] text-base leading-4 px-6 py-4",
                {
                  "border-purple-dark text-purple-dark": s
                },
                {
                  "border-green-dark text-green-dark": n
                },
                o === r.value ? {
                  "bg-green-dark text-white": n,
                  "bg-purple-dark text-white": s
                } : null
              ),
              children: r.label
            },
            r.value
          )) }) : /* @__PURE__ */ e.jsxs("div", { className: "flex w-full items-center gap-2", children: [
            /* @__PURE__ */ e.jsx(
              "input",
              {
                type: "text",
                value: o,
                onChange: m,
                onFocus: p,
                onBlur: b,
                placeholder: g,
                className: l(
                  j,
                  "h-[42px] flex-grow flex-shrink w-full border-b border-grey-200 focus:outline-none text-center text-md",
                  t === "number" && "appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ",
                  {
                    "text-green-dark": n,
                    "text-black": s
                  }
                ),
                inputMode: t === "number" ? "numeric" : "text",
                maxLength: t === "number" ? 3 : void 0
              }
            ),
            t !== "dropdown" && h && /* @__PURE__ */ e.jsx("span", { className: "text-grey-400 font-demi flex-shrink-0", children: h })
          ] }) })
        ]
      }
    ),
    u && /* @__PURE__ */ e.jsx("div", { className: "bg-red-error mt-2 text-white font-demi rounded-2xl gap-2 p-2", children: u })
  ] });
};
export {
  L as default
};
